import {CommonMessages} from '../common.messages';

export const PanelOrderRoutesMessages = {

    BrokerCreationSucceed: {
        key: 'BrokerCreationSucceed',
        message: 'Broker is successfully created.'
    },
    BrokerCreationFailed: {
        key: 'BrokerCreationFailed',
        message: 'Error while processing request. Unable to create a Broker.'
    },
    RouteCreationSucceed: {
        key: 'RouteCreationSucceed',
        message: 'Route is successfully created.'
    },
    RouteCreationFailed: {
        key: 'RouteCreationFailed',
        message: 'Error while processing request. Unable to create a Route.'
    },
    RouteUpdateSucceed: {
        key: 'RouteUpdateSucceed',
        message: 'Route is successfully updated.'
    },
    RouteUpdateFailed: {
        key: 'RouteUpdateFailed',
        message: 'Error while processing request. Unable to update a Route.'
    },
    RouteSetCreationSucceed: {
        key: 'RouteSetCreationSucceed',
        message: 'RouteSet is successfully created.'
    },
    RouteSetCreationFailed: {
        key: 'RouteSetCreationFailed',
        message: 'Error while processing request. Unable to create a RouteSet.'
    },
    RouteSetUpdateSucceed: {
        key: 'RouteSetUpdateSucceed',
        message: 'Route Set is successfully updated.'
    },
    RouteSetUpdateFailed: {
        key: 'RouteSetUpdateFailed',
        message: 'Error while processing request. Unable to update a Route Set.'
    },
    BrokerGetFailed: {
        key: 'BrokerGetFailed',
        message: 'Unable to get Broker.'
    },
    UpdateStatusFailed: {
        key: 'UpdateStatusFailed',
        message: 'Unable to update Broker status.'
    },
    UpdateStatusSuccess: {
        key: 'UpdateStatusSuccess',
        message: 'Broker status successfully updated.'
    },
    BrokerUpdateSucceed: {
        key: 'BrokerUpdateSucceed',
        message: 'Broker is successfully updated.'
    },
    BrokerUpdateFailed: {
        key: 'BrokerUpdateFailed',
        message: 'Error while processing request. Unable to update Broker.'
    },
    ...CommonMessages
};
